import { ReactKit } from '@team/react';
import { Layout } from './components/layout';
import { Header } from './components/header';

export const Group = ReactKit.createCompoundComponent(Layout, { Header });

Layout.displayName = 'Group';
Header.displayName = 'GroupHeader';

export type {
  LayoutProps as GroupProps,
  HeaderProps as GroupHeaderProps,
} from './types';
